import th from 'date-fns/locale/th';
import { format } from 'date-fns';
import { addYears } from 'date-fns/esm/fp';
export const ConvertDateToThaiBuddhist = (date) => {
      const selectedDate = date ? new Date(date) : null; 
      const selectedDateInBE = selectedDate ? addYears(543, selectedDate) : null;
      const monthInThai = selectedDateInBE ? format(selectedDateInBE, 'MMMM', { locale: th }) : null;
      const formattedDate = selectedDateInBE ? format(selectedDateInBE, 'd') + ' ' + monthInThai + ' ' + format(selectedDateInBE, 'yyyy') : null;
      return formattedDate
}